import { AlternateUrlType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { setLocaleCookie } from '@infrastructure/Cookies'
import { ensureTrailingSlash } from '@infrastructure/Url/ensureTrailingSlash'
import { NavigateFn } from '@reach/router'
import { getPageUrl } from '@src/Application/Utils/generalUtils'

export const onChangeLanguage = (lang: string, navigate: NavigateFn, alterPageUrl?: string | null) => (): void => {
    setLocaleCookie(lang)

    if (alterPageUrl) {
        navigate(alterPageUrl)
    } else {
        navigate(lang === 'en' ? '/' : `/${lang}/`)
    }
}

export const getAlternativePageUrl = (lang: string, alternateUrls?: Nullable<AlternateUrlType[]>): string | null => {
    const alternatePage = alternateUrls?.find((a) => a.language === lang)
    const url = alternatePage ? getPageUrl(alternatePage) : null

    if (!url) return null

    return lang === 'en' ? ensureTrailingSlash(url) : ensureTrailingSlash(`/${lang}/${url}`.replace(/\/\//gi, '/'))
}
